import { Component, Prop, h } from '@stencil/core';
import { getConstant } from '../../../../../utils/constants-helpers';
import { parseJsonProp } from '../../../../../utils/helpers/hydration';

/**
 * FAQ component for SignNow brand frequently asked questions
 *
 * @product signnow
 * @source faq
 * @version 1.0.2
 * @category faq
 * @contentConfig FAQ component for displaying frequently asked questions
 * @constant FAQ_HEADING_TITLE - "FAQs" - Main heading for FAQ section
 * @constant FAQ_SUBHEADING_DESCRIPTION - "Here is a list of the most common customer questions. If you can't find an answer to your question, please don't hesitate to reach out to us." - Description text for FAQ section
 * @constant FAQ_CONTACT_SUPPORT_BUTTON - "Contact support" - Contact support button text
 * @slot heading - {required}, <me-heading variant="2"> - Main heading for FAQ section
 * @slot subheading - <me-text tag="p" variant="large"> - Description text for FAQ section
 */
@Component({
  tag: 'sn-faq-type-2',
  shadow: false,
})
export class SNFAQType2 {
  /**
   * Component constants object containing all required text constants
   */
  @Prop({ mutable: true }) constants?: Record<string, string> | string;

  /**
   * HTML tag for the heading element (h1, h2, h3, h4, h5, h6)
   * @default "h2"
   */
  @Prop() headingTag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' = 'h2';

  /**
   * @dynamic
   * @type {array}
   * @.type {object}
   * @.property {string} question - The question text
   * @.property {string} answer - The answer content, supports HTML
   * @.required question
   * @.required answer
   * @minItems 3
   */
  @Prop({ mutable: true }) items: any[] | string = [];

  componentWillLoad() {
    this.constants = parseJsonProp(this.constants);
    this.items = parseJsonProp(this.items, []);
  }

  render() {
    if (!Array.isArray(this.items)) {
      return null;
    }

    return (
      <faq-type-2 items={this.items}>
        <me-heading slot="heading" variant="2" tag={this.headingTag}>
          {getConstant(this.constants, 'FAQ_HEADING_TITLE', 'FAQs')}
        </me-heading>
        <me-text slot="subheading" tag="p" variant="large">
          {getConstant(
            this.constants,
            'FAQ_SUBHEADING_DESCRIPTION',
            "Here is a list of the most common customer questions. If you can't find an answer to your question, please don't hesitate to reach out to us.",
          )}
        </me-text>
        {/* <me-button slot="action-primary" variant="secondary" href="https://signnow.com/contact">
          {getConstant(this.constants, 'FAQ_CONTACT_SUPPORT_BUTTON', 'Contact support')}
        </me-button> */}
      </faq-type-2>
    );
  }
}
